<div
  #compareContainer
  class="landing-compare"
  (click)="onContainerClick($event)"
  role="img"
  [attr.aria-label]="'landing.landing_1.compare.aria_label' | translate">
  <div class="landing-compare__mode-bar" role="group" [attr.aria-label]="'landing.landing_1.compare.mode_group' | translate">
    <button
      type="button"
      class="landing-compare__mode-btn"
      [class.landing-compare__mode-btn--active]="isLightActive()"
      (click)="onModeToggle('light'); $event.stopPropagation()"
      [attr.aria-pressed]="isLightActive()"
      [attr.aria-label]="'landing.landing_1.compare.light_mode' | translate">
      <i-tabler name="sun" class="landing-compare__mode-icon"></i-tabler>
    </button>
    <button
      type="button"
      class="landing-compare__mode-btn"
      [class.landing-compare__mode-btn--active]="!isLightActive()"
      (click)="onModeToggle('dark'); $event.stopPropagation()"
      [attr.aria-pressed]="!isLightActive()"
      [attr.aria-label]="'landing.landing_1.compare.dark_mode' | translate">
      <i-tabler name="moon" class="landing-compare__mode-icon"></i-tabler>
    </button>
  </div>

  <img
    class="landing-compare__image landing-compare__image--dark"
    [src]="assets.dashboardDark"
    width="1910"
    height="903"
    [alt]="'landing.landing_1.compare.dark_alt' | translate"
    loading="eager" />

  <div
    class="landing-compare__light-layer"
    [style.clip-path]="'inset(0 ' + (100 - sliderPosition()) + '% 0 0)'">
    <img
      class="landing-compare__image landing-compare__image--light"
      [src]="assets.dashboardLight"
      width="1910"
      height="903"
      [alt]="'landing.landing_1.compare.light_alt' | translate"
      loading="eager" />
  </div>

  <div class="landing-compare__divider" [style.left.%]="sliderPosition()">
    <button
      type="button"
      class="landing-compare__handle"
      (pointerdown)="onHandlePointerDown($event)"
      [attr.aria-label]="'landing.landing_1.compare.drag_hint' | translate">
      <i-tabler name="chevron-left" class="landing-compare__handle-icon"></i-tabler>
      <i-tabler name="chevron-right" class="landing-compare__handle-icon"></i-tabler>
    </button>
  </div>
</div>
